import { observer } from 'mobx-react-lite';
import { useEffect } from 'react';
import { useLeadStore } from '../..';
import useInsightsShape from '../../hooks/useInsightsShape';
import useLeadsInsideShape from '../../hooks/useLeadsInsideShape';
import useLeadsWithGlobalFilters from '../../hooks/useLeadsWithGlobalFilters';
import { IDetailsTabProps } from '../../interfaces/IDetailsTabProps';
import LeadsGrid from '../leads/LeadsGrid';

function InsightsLeadsTab({ visible, setEntityCount }: IDetailsTabProps) {
    const leadStore = useLeadStore();
    const insightsShape = useInsightsShape();
    const leads = useLeadsWithGlobalFilters(useLeadsInsideShape(leadStore.leads, insightsShape));

    useEffect(() => setEntityCount(leads.length), [leads]);

    if (!visible || !insightsShape)
        return null;

    return (
        <LeadsGrid leads={leads} />
    );
}

export default observer(InsightsLeadsTab);